import React from 'react';

const panelStyle = {
  minHeight: '100vh',
  display: 'grid',
  placeItems: 'center',
  padding: 20,
  background: '#fafaf7',
  color: '#0f172a',
  fontFamily: "'DM Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};

const cardStyle = {
  width: 'min(100%, 440px)',
  borderRadius: 12,
  border: '1px solid rgba(15,23,42,0.12)',
  background: '#fff',
  boxShadow: 'none',
  padding: 'clamp(18px, 5vw, 32px)',
};

const buttonStyle = {
  minHeight: 44,
  borderRadius: 10,
  border: 'none',
  background: 'linear-gradient(135deg,#0C69C8 0%,#0A1D44 100%)',
  color: '#fff',
  padding: '10px 14px',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
};

const secondaryButtonStyle = {
  ...buttonStyle,
  border: '1px solid rgba(15,23,42,0.14)',
  background: '#fff',
  color: '#0f172a',
};

function AppErrorScreen({ title = 'We could not load this page' }) {
  return (
    <main style={panelStyle}>
      <section role="alert" aria-live="assertive" style={cardStyle}>
        <div style={{ display: 'grid', gap: 14 }}>
          <h1 style={{ margin: 0, color: '#0f172a', fontSize: 'clamp(22px, 5vw, 28px)', lineHeight: 1.08, letterSpacing: 0, fontWeight: 400 }}>
            {title}
          </h1>
          <p style={{ margin: 0, color: '#475569', fontSize: 15, lineHeight: 1.55, fontWeight: 400 }}>
            Try refreshing this page, or return home to continue.
          </p>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
            <button type="button" onClick={() => window.location.reload()} style={buttonStyle}>
              Refresh page
            </button>
            <button type="button" onClick={() => { window.location.href = '/'; }} style={secondaryButtonStyle}>
              Back to home
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, eventType: '' };
  }

  static getDerivedStateFromError(error) {
    return { error, eventType: 'react-render' };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App render error:', error, errorInfo);
    this.setState({ error, errorInfo, eventType: 'react-render' });
  }

  componentDidMount() {
    this.errorListener = (event) => {
      if (String(event.message || '').includes('ResizeObserver loop completed with undelivered notifications')) {
        return;
      }
      console.error('Background browser error:', event.error || event.message);
    };
    this.rejectionListener = (event) => {
      console.error('Background request error:', event.reason);
    };
    window.addEventListener('error', this.errorListener);
    window.addEventListener('unhandledrejection', this.rejectionListener);
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.errorListener);
    window.removeEventListener('unhandledrejection', this.rejectionListener);
  }

  render() {
    if (this.state.error) {
      return <AppErrorScreen />;
    }

    return this.props.children;
  }
}
